<template>
  <component :is="wrapperIs" v-bind="wrapperBind">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-width="embedded ? '120px' : '108px'"
      size="medium"
      :class="['sub-form', { 'form-page-form': !embedded }]"
    >
      <template v-if="!embedded && !isEdit">
        <el-divider content-position="left">{{ $t('subcontractorFormPage.sectionMain') }}</el-divider>
      </template>
      <el-row v-if="embedded" :gutter="16">
        <el-col :span="12">
          <el-form-item :label="$t('subcontractorFormPage.companyLegal')">
            <el-input v-model="form.companyName" :placeholder="$t('subcontractorFormPage.companyLegalPh')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('subcontractorFormPage.tradeName')" prop="subcontractorName">
            <el-input v-model="form.subcontractorName" :placeholder="$t('subcontractorFormPage.tradeNamePh')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="embedded" :gutter="16">
        <el-col :span="12">
          <el-form-item :label="$t('subcontractorFormPage.partyType')">
            <el-select v-model="form.partyTypeCode" style="width:100%;">
              <el-option :label="$t('enum.subcontractorParty.1')" :value="1" />
              <el-option :label="$t('enum.subcontractorParty.2')" :value="2" />
              <el-option :label="$t('enum.subcontractorParty.3')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-else>
        <el-form-item :label="$t('subcontractorFormPage.companyLegal')">
          <el-input v-model="form.companyName" :placeholder="$t('subcontractorFormPage.companyLegalPh')" clearable />
        </el-form-item>
        <el-form-item :label="$t('subcontractorFormPage.tradeName')" prop="subcontractorName">
          <el-input v-model="form.subcontractorName" :placeholder="$t('subcontractorFormPage.tradeNamePh')" clearable />
        </el-form-item>
        <el-form-item :label="$t('subcontractorFormPage.partyType')">
          <el-select v-model="form.partyTypeCode" style="width:100%;max-width:420px;">
            <el-option :label="$t('enum.subcontractorParty.1')" :value="1" />
            <el-option :label="$t('enum.subcontractorParty.2')" :value="2" />
            <el-option :label="$t('enum.subcontractorParty.3')" :value="3" />
          </el-select>
        </el-form-item>
      </template>
      <el-row v-if="embedded" :gutter="16">
        <el-col :span="12">
          <el-form-item :label="$t('subcontractorFormPage.contact')">
            <el-input v-model="form.contactPerson" :placeholder="$t('subcontractorFormPage.contactPh')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('subcontractorFormPage.licenseNo')">
            <el-input v-model="form.licenseNo" :placeholder="$t('subcontractorFormPage.licensePh')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <template v-else>
        <el-form-item :label="$t('subcontractorFormPage.contact')">
          <el-input v-model="form.contactPerson" :placeholder="$t('subcontractorFormPage.contactPh')" clearable />
        </el-form-item>
        <template v-if="!isEdit">
          <el-divider content-position="left">{{ $t('subcontractorFormPage.sectionLicense') }}</el-divider>
        </template>
        <el-form-item :label="$t('subcontractorFormPage.licenseNo')">
          <el-input v-model="form.licenseNo" :placeholder="$t('subcontractorFormPage.licensePh')" clearable />
        </el-form-item>
      </template>
      <el-form-item :label="$t('subcontractorFormPage.insurance')">
        <el-input v-model="form.insuranceInfo" type="textarea" :rows="embedded ? 2 : 3" :placeholder="$t('subcontractorFormPage.insurancePh')" />
      </el-form-item>
      <el-row v-if="embedded" :gutter="16">
        <el-col :span="12">
          <el-form-item :label="$t('grid.phone')">
            <el-input v-model="form.phone" :placeholder="$t('subcontractorFormPage.phonePh')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('grid.email')">
            <el-input v-model="form.email" :placeholder="$t('subcontractorFormPage.emailPh')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <template v-else>
        <el-form-item :label="$t('grid.phone')">
          <el-input v-model="form.phone" :placeholder="$t('subcontractorFormPage.phonePh')" clearable />
        </el-form-item>
        <el-form-item :label="$t('grid.email')">
          <el-input v-model="form.email" :placeholder="$t('subcontractorFormPage.emailPh')" clearable />
        </el-form-item>
      </template>
      <el-form-item v-if="!embedded" class="form-page-form__actions">
        <el-button type="primary" :loading="saving" @click="submit">{{ $t('common.save') }}</el-button>
        <el-button @click="$router.push('/subcontractor/list')">{{ $t('common.backToList') }}</el-button>
      </el-form-item>
    </el-form>
  </component>
</template>

<script>
import { getSubcontractor, saveSubcontractor, updateSubcontractor } from '@/api/subcontractor'
import FormPageShell from '@/components/FormPageShell.vue'

export default {
  name: 'SubcontractorForm',
  components: { FormPageShell },
  props: {
    embedded: { type: Boolean, default: false },
    recordId: { type: [String, Number], default: null }
  },
  data() {
    return {
      isEdit: false,
      saving: false,
      form: {
        companyName: '',
        subcontractorName: '',
        partyTypeCode: 3,
        contactPerson: '',
        licenseNo: '',
        insuranceInfo: '',
        phone: '',
        email: ''
      }
    }
  },
  computed: {
    wrapperIs() {
      return this.embedded ? 'div' : 'FormPageShell'
    },
    wrapperBind() {
      if (this.embedded) {
        return { class: 'sub-form__embed' }
      }
      return {
        isEdit: this.isEdit,
        title: this.isEdit ? this.$t('subcontractorFormPage.editTitle') : this.$t('subcontractorFormPage.newTitle'),
        subtitle: this.isEdit ? '' : this.$t('subcontractorFormPage.newSubtitle'),
        icon: 'el-icon-office-building',
        theme: 'success'
      }
    },
    rules() {
      return {
        subcontractorName: [{ required: true, message: this.$t('subcontractorFormPage.ruleName'), trigger: 'blur' }]
      }
    }
  },
  async created() {
    if (this.embedded) {
      const rid = this.recordId
      this.isEdit = rid != null && rid !== ''
      if (this.isEdit) {
        try {
          await this.loadDetail(rid)
        } catch (e) {
          this.$emit('cancel')
        }
      }
      return
    }
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      await this.loadDetail(id)
    }
  },
  methods: {
    editId() {
      if (this.embedded) return this.recordId
      return this.$route.params.id
    },
    async loadDetail(id) {
      try {
        const r = await getSubcontractor(id)
        const row = (r && r.data) || r
        if (!row || !row.id) {
          this.$message.error(this.$t('subcontractorFormPage.notFound'))
          if (!this.embedded) this.$router.replace('/subcontractor/list')
          throw new Error('not found')
        }
        this.form = {
          companyName: row.companyName || '',
          subcontractorName: row.subcontractorName || '',
          partyTypeCode: row.partyTypeCode != null ? Number(row.partyTypeCode) : 3,
          contactPerson: row.contactPerson || '',
          licenseNo: row.licenseNo || '',
          insuranceInfo: row.insuranceInfo || '',
          phone: row.phone || '',
          email: row.email || ''
        }
      } catch (e) {
        if (e.message !== 'not found') {
          this.$message.error((e && e.message) || this.$t('common.loadFailed'))
          if (!this.embedded) this.$router.replace('/subcontractor/list')
        }
        throw e
      }
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        this.$emit('saving', true)
        try {
          if (this.isEdit) {
            await updateSubcontractor(this.editId(), this.form)
            this.$message.success(this.$t('subcontractorFormPage.saved'))
          } else {
            await saveSubcontractor(this.form)
            this.$message.success(this.$t('subcontractorFormPage.created'))
          }
          if (this.embedded) {
            this.$emit('saved')
          } else {
            this.$router.push('/subcontractor/list')
          }
        } catch (e) {
          this.$message.error((e && e.message) || this.$t('subcontractorFormPage.failed'))
        } finally {
          this.saving = false
          this.$emit('saving', false)
        }
      })
    }
  }
}
</script>

<style scoped>
.form-page-form {
  max-width: 100%;
}

.sub-form__embed {
  min-width: 0;
}

.form-page-form__actions {
  margin-top: 8px;
  margin-bottom: 0;
}
</style>
